import React, { ReactNode } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { getCountChecked } from '@mineko/mineko-utils';
import { Logo, PartnerLogo } from '../icons';
import HeaderText from './HeaderText';
import Highlighted from '../text/Highlighted';
import { UserMenu } from '../userMenu/UserMenu';

type User = { name: string; email: string };

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      boxShadow: 'unset',
    },
    toolBar: {
      height: 70,
      borderBottom: `1px solid ${theme.palette.grey.A100}`,
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 13,
        paddingRight: 13,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
      [theme.breakpoints.down('xs')]: {
        marginRight: theme.spacing(1),
      },
      [theme.breakpoints.down(360)]: {
        marginRight: 0,
      },
    },
    menuIcon: {
      fontSize: 32,
    },
    logo: {
      flexGrow: 1,
      textAlign: 'left',
      height: 35,
      cursor: 'pointer',
    },
    claimBlock: {
      display: 'flex' as const,
      justifyContent: 'flex-end',
      fontFamily: 'Open Sans, sans-serif',
    },
  }),
);

interface Props {
  logoOnClick?: any;
  claim?: ReactNode;
  withTrust?: boolean;
  onBurgerClick?: any;
  logoClaimText?: string;
  logo?: string;
  user?: User;
}

const Header: React.FC<Props> = ({ logoOnClick, claim, withTrust, onBurgerClick, logoClaimText, logo, user }) => {
  const classes = useStyles();
  return (
    <AppBar position="static" color="inherit" className={classes.root}>
      <Toolbar className={classes.toolBar}>
        {onBurgerClick && (
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={onBurgerClick}
          >
            <MenuIcon className={classes.menuIcon} />
          </IconButton>
        )}
        <div className={classes.logo}>
          <Logo onClick={logoOnClick} claimText={logoClaimText} />
        </div>

        <PartnerLogo withTrust={withTrust} logo={logo} />

        {claim && (
          <div className={classes.claimBlock}>
            <HeaderText text={claim} />
          </div>
        )}

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

Header.defaultProps = {
  claim: (
    <div>
      Bereits <Highlighted>{getCountChecked()}</Highlighted> Nebenkostenabrechnungen geprüft.
    </div>
  ),
  withTrust: true,
};

export default Header;
